module.exports = __webpack_public_path__ + "static/media/PanaxiaLogo.57d28906.svg";